var chunkToChildrenMap = {
	"1189": [
		1218
	],
	"1218": [
		1218
	],
	"1911": [
		1218
	],
	"2348": [
		1189,
		1218
	],
	"4882": [
		1189,
		1218
	],
	"5123": [
		1189,
		1218
	],
	"7339": [
		1189,
		1218
	],
	"7366": [
		1189,
		1218
	],
	"7996": [
		1189,
		1218
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };